import { render, staticRenderFns } from "./detailClaimCorporate.vue?vue&type=template&id=397cec4e&scoped=true&"
import script from "./detailClaimCorporate.vue?vue&type=script&lang=js&"
export * from "./detailClaimCorporate.vue?vue&type=script&lang=js&"
import style0 from "./detailClaimCorporate.vue?vue&type=style&index=0&id=397cec4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397cec4e",
  null
  
)

export default component.exports